module.exports = __webpack_public_path__ + "static/media/photo.c195fcb7.svg";